import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { invalidateSharingQueries } from "../../lib/invalidateSharing";
import { useAuth } from "../../contexts/AuthContext";

// Answering an Invitation the banner shows: accept flips the caller's own
// row to "accepted" (self-service — list_members' own trigger refuses
// anything else changing on the row); decline deletes it outright, since
// declining someone isn't a Member yet, so there's no membership left to
// hold open. Both are the invited person acting on their own row, which
// list_members' RLS already allows unconditionally.
export function useRespondToInvitation() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async ({
      listId,
      accept,
    }: {
      listId: string;
      accept: boolean;
    }): Promise<void> => {
      if (!user) throw new Error("Not authenticated");
      if (accept) {
        const { error } = await supabase
          .from("list_members")
          .update({ status: "accepted" })
          .eq("list_id", listId)
          .eq("user_id", user.id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from("list_members")
          .delete()
          .eq("list_id", listId)
          .eq("user_id", user.id);
        if (error) throw error;
      }
    },

    onSuccess: (_result, { listId }) => {
      invalidateSharingQueries(queryClient, listId);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useRespondToInvitation" } });
      toast.error("Couldn't save that. Please try again.");
    },
  });
}
